import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Text } from '@nerdwallet/react-typography';

const HeroNavTile = ({
  nav,
  IconComponent,
  iconColor,
  backgroundColor,
  url,
}) => (
  <a
    href={url}
    className={classNames([
      'hero-nav__tile-container',
      classes(['margin-bottom-3', 'display-block']),
    ])}
  >
    <div
      className={classNames([
        'hero-nav__tile',
        classes([
          'display-flex',
          'flex-direction-row',
          'align-items-center',
          'border-radius-1',
        ]),
      ])}
    >
      <div style={{ backgroundColor }} className="hero-nav__icon-container">
        <IconComponent
          color={iconColor}
          size={48}
          className={classNames([
            classes(['width-100', 'height-100', 'padding-all-1']),
          ])}
        />
      </div>
      <Text className="hero-nav__text">{nav}</Text>
    </div>
  </a>
);

HeroNavTile.propTypes = {
  nav: PropTypes.string,
  IconComponent: PropTypes.node,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  url: PropTypes.string,
};

HeroNavTile.displayName = 'HeroNavTile';

export default HeroNavTile;
